export default class ConversationalSearchService {
    static async parseQuery(query) {
        const response = await axios.post('/mapa/busca-conversacional', { query });
        return response.data;
    }
}
